export type AggregatorListValue ={
    aggregatorId: number,
    name: string
} | null;